/**
 * Lenis (Smooth Scroll) 初期化
 */

(function() {
    'use strict';

    /**
     * Lenisの初期化
     */
    function initLenis() {
        if (typeof Lenis === 'undefined') {
            console.warn('Lenis library is not loaded');
            return null;
        }

        // prefers-reduced-motionをチェック
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        
        if (prefersReducedMotion) {
            // アニメーションを無効化する設定の場合、Lenisを初期化しない
            return null;
        }

        // Lenisインスタンスを作成
        const lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            orientation: 'vertical',
            gestureOrientation: 'vertical',
            smoothWheel: true,
            wheelMultiplier: 0.8, // 1から0.8に下げる（より滑らかに）
            smoothTouch: false,
            touchMultiplier: 2,
            infinite: false,
            lerp: 0.1 // 補間率を調整（デフォルトより滑らかに）
        });

        // アニメーションフレームでLenisを更新（最適化版）
        let rafId;
        function raf(time) {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        }
        rafId = requestAnimationFrame(raf);

        // ページが非アクティブになったらRAFを停止（パフォーマンス向上）
        document.addEventListener('visibilitychange', function() {
            if (document.hidden) {
                if (rafId) {
                    cancelAnimationFrame(rafId);
                    rafId = null;
                }
            } else {
                if (!rafId) {
                    rafId = requestAnimationFrame(raf);
                }
            }
        });

        // グローバルに公開
        window.lenis = lenis;

        // 初期化完了を通知
        window.dispatchEvent(new CustomEvent('lenis:ready', { detail: lenis }));

        // 画像読み込み完了後にLenisを再計算（レイアウトシフト対策）
        window.addEventListener('load', function() {
            if (lenis && typeof lenis.resize === 'function') {
                lenis.resize();
            }
        });

        // 画像の遅延読み込み完了を監視
        function handleImageLoad() {
            if (lenis && typeof lenis.resize === 'function') {
                lenis.resize();
            }
        }

        // 既存の画像を監視
        const images = document.querySelectorAll('img[loading="lazy"]');
        images.forEach(function(img) {
            if (img.complete) {
                // 既に読み込み済みの場合は即座にresize
                handleImageLoad();
            } else {
                img.addEventListener('load', handleImageLoad, { once: true });
                img.addEventListener('error', handleImageLoad, { once: true });
            }
        });

        // 動的に追加される画像も監視（MutationObserver）
        if (typeof MutationObserver !== 'undefined') {
            const imageObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) { // Element node
                            if (node.tagName === 'IMG' && node.getAttribute('loading') === 'lazy') {
                                if (node.complete) {
                                    handleImageLoad();
                                } else {
                                    node.addEventListener('load', handleImageLoad, { once: true });
                                    node.addEventListener('error', handleImageLoad, { once: true });
                                }
                            }
                            // 子要素内の画像も監視
                            const lazyImages = node.querySelectorAll && node.querySelectorAll('img[loading="lazy"]');
                            if (lazyImages) {
                                lazyImages.forEach(function(img) {
                                    if (img.complete) {
                                        handleImageLoad();
                                    } else {
                                        img.addEventListener('load', handleImageLoad, { once: true });
                                        img.addEventListener('error', handleImageLoad, { once: true });
                                    }
                                });
                            }
                        }
                    });
                });
            });

            imageObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        }

        return lenis;
    }

    // DOMContentLoadedで確実に実行
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLenis);
    } else {
        initLenis();
    }
})();

